import React from 'react'
import routes from '../../../config/routes'
import history from '../../../lib/history'
import ExternalLayout from '../../commons/Layouts/ExternalLayout'
import FeedbackLayout from '../../commons/Layouts/FeedbackLayout'
import successfullImg from './successfullImg.svg'

export const TITLE = 'Cadastro feito com sucesso!'

export const SUBTITLE =
  'O seu cadastro foi feito com sucesso. Faça o login com a sua nova senha.'

export const PRIMARY_LABEL = 'OK'

const RegisterSuccessfulFeedbackContainer = () => (
  <ExternalLayout>
    <FeedbackLayout
      title={TITLE}
      subTitle={SUBTITLE}
      primaryAction={() => history.push(routes.login.path)}
      primaryLabelAction={PRIMARY_LABEL}
      image={successfullImg}
    />
  </ExternalLayout>
)

export default RegisterSuccessfulFeedbackContainer
